import React from 'react';
import PropTypes from 'prop-types';
import Font from '@mui/icons-material/HowToReg';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import ApprovalTypeDecisionReasonsListItemComponent from './ApprovalTypeDecisionReasonsListItemComponent';

const ApprovalTypeDecisionReasonsListComponent = ({ approvalTypeDecisionReasons, dispatch }) => {
  const { t } = useTranslation();
  const onAdd = () => {
    dispatch({ type: 'OnAddReason' });
  };

  return (
    <Card
      icon={Font}
      iconColor='primary'
      title={t('ApprovalTypes.ApprovalTypeDecisionReasons.Title')}
      actions={<IconButton type='add' fontSize='medium' color='transparent' tooltip={t('Tooltips.Add')} onClick={() => onAdd()} />}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('ApprovalTypes.ApprovalTypeDecisionReasons.Reason')}</TableCell>
            <TableCell align='right'>{t('ApprovalTypes.ApprovalTypeDecisionReasons.Actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {approvalTypeDecisionReasons.map((item, idx) => {
            return <ApprovalTypeDecisionReasonsListItemComponent reason={item} key={idx} index={idx} dispatch={dispatch} />;
          })}
        </TableBody>
      </Table>
    </Card>
  );
};

ApprovalTypeDecisionReasonsListComponent.propTypes = {
  approvalTypeDecisionReasons: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default ApprovalTypeDecisionReasonsListComponent;
